'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListView = require('./ListView.web');

var _ListView2 = _interopRequireDefault(_ListView);

var _Indexed = require('./Indexed.web');

var _Indexed2 = _interopRequireDefault(_Indexed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// export this package's api
_ListView2["default"].IndexedList = _Indexed2["default"];
exports["default"] = _ListView2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-list-view/lib/index.js
 ** module id = 119
 ** module chunks = 0
 **/